import { useNavigate } from 'react-router';
import intl from 'components/i18n/ReactIntlWrapper';
import { Box, Chip, IconButton, Typography } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import WorkflowActionsBar from '../../Workflow/WorkflowActionsBar';
import { WorkflowProvider } from 'components/Workflow/WorkflowContext';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { formatDateInvoices } from '../../../common/utils';
import { getStatusColor } from 'components/color-utils/status-color';
import { WorkflowStatusChip } from 'components/common/WorkflowStatusChip';

const MyInvoicesList = ({
  searchResult,
  isValidating,
  loading,
  paginationModel,
  onPaginationModelChange,
  sortModel,
  onSortModelChange,
  statuses,
  workflowModuleId
}) => {
  const navigate = useNavigate();

  const columns = [];

  const handleInvoiceDetail = (invoiceID, jobId) => {
    if (isValidating) {
      navigate(`/accountspayable/detail/${jobId}`);
    } else {
      navigate(`/invoice/detail/${invoiceID}`);
    }
  };
  const handleSave = () => {};

  columns.push(
    {
      field: 'date',
      headerName: intl.get('invoicesList.date'),
      width: 250,
      flex: 1,
      renderCell: (params) => <>{formatDateInvoices(params.row.date)}</>,
    },
    {
      field: 'number',
      headerName: intl.get('invoicesList.invoice.number'),
      width: 250,
      flex: 1,
      sortable: false,
    },
    {
      field: 'amount',
      headerName: intl.get('invoicesList.amount'),
      width: 250,
      flex: 1,
    },
    {
      field: 'status',
      headerName: intl.get('invoicesList.status'),
      width: 250,
      flex: 1,
      sortable: false,
      renderCell: (params) => (
        <WorkflowStatusChip stateId={params.row.idWorkflowState} />  
      ),
    }
  );

  if (isValidating) {
    columns.unshift({
      field: 'name',
      headerName: intl.get('invoicesList.name'),
      width: 250,
      flex: 1,
      renderCell: (params) => (
        <>
          {isValidating
            ? params.row.senderName === null || params.row.senderName === ''
              ? '-'
              : params.row.senderName
            : params.row.from === null || params.row.from === ''
              ? '-'
              : params.row.from}
        </>
      ),
    });
  }

  if (!isValidating) {
    columns.push({
      field: 'id',
      headerName: intl.get('invoicesList.invoice.id'),
      width: 250,
      flex: 1,
      sortable: false,
    });

    columns.push({
      field: 'workflowActions',
      headerName: intl.get('invoicesList.actions'),
      width: 150,
      sortable: false,
      renderCell: (params) => (
        <WorkflowActionsBar
          viewMode="icons"
          onActionClick={handleSave}
          id={params.row.id}
          stateId={params.row.idWorkflowState}
          loading={loading}
        />
      ),
    });
  }

  columns.push({
    field: 'actions',
    headerName: intl.get('invoicesList.detail'),
    width: 150,
    sortable: false,
    renderCell: (params) => (
      <Box display="flex" justifyContent="center">
        <IconButton onClick={() => handleInvoiceDetail(params.row.id, params.row.jobId)}>
          <VisibilityIcon />
        </IconButton>
      </Box>
    ),
  });

  return (
        <Box style={{ width: '100%', display: 'flex' }}>
          <WorkflowProvider moduleId={workflowModuleId}>
            <DataGrid
              rows={searchResult?.queryResult || []}
              getRowId={(row) => (row.id === 0 ? row.jobId : row.id)}
              columns={columns}
              loading={loading}
              rowCount={searchResult?.totalRecords || 0}
              paginationModel={paginationModel}
              onPaginationModelChange={onPaginationModelChange}
              sortModel={sortModel}
              onSortModelChange={onSortModelChange}
              pageSizeOptions={[5, 10, 20]}
              paginationMode="server"
              sortingMode="client"
            />
          </WorkflowProvider>
        </Box>
  );
};

export default MyInvoicesList;
